import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import "../modal.css";
import InputField from "../../form/inputField/inputField";

const ReimburseModal = ({ show, handleClose }) => {
  const initialValues = {
    Credit_note_id: "",
  };
  const validationSchema = Yup.object().shape({
    Credit_note_id: Yup.string().trim().required("Required"),
  });

  const onSubmit = (values) => {
    console.log(values);
  };
  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName=""
      contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
    >
      <ModalHeader>
        <span className="fn_Nunito fw_600 fs_16 my-2 px-0 Medium_Purple">
          REIMBURSE
        </span>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="p-1">
              <div className="my-2">
                <InputField
                  id={"Credit_note_id"}
                  label={"Credit note ID"}
                  labelColor={"color_262c3d"}
                  type={"text"}
                  placeholder={"Enter credit note id"}
                  name={"Credit_note_id"}
                />
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button
                  type="submit"
                  className="modal-submit-btn fs_14 text-white py-2 px-4 fw_700"
                  style={{ width: "130px" }}
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="modal-logout-btn fs_14 fw_700 px-3 py-2"
                  style={{ width: "90px" }}
                >
                  CLOSE
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default ReimburseModal;
